<app-aggregated-amount-item
  name="YouTube チャンネル"
  icon="./assets/youtube_logo.png"
  amount="{{ (youtubeChannelSubscribersCountModel$ | async)?.units }}"
  [hasAmount]="(youtubeChannelSubscribersCountModel$ | async)?.hasUnits"
  unit="登録者数"
  [rate]="(youtubeChannelSubscribersCountModel$ | async)?.rate"
  link="{{ ((selectedArtist$ | async)?.youtube.urls)[0] }}"
  help="{{
    !((selectedArtist$ | async)?.youtube.urls)[0]
      ? 'YouTube'
      : ((selectedArtist$ | async)?.youtube.urls)[0]
  }} のチャンネル登録者数です。選択期間内に取得できた最新の値を表示しています。"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
  [isDecimal]="true"
></app-aggregated-amount-item>
